import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-28 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-10 h-10 mx-auto mb-4 text-white/70" />
      <h1 className="font-display text-display-xs mb-3">Checkout Cancelled</h1>
      <p className="text-white/60 mb-8">No payment was made. You can try again anytime.</p>
      <Link to="/gold" data-testid="payment-cancel-gold-link" className="text-xs uppercase tracking-wide text-brandAccent underline">Back to Gold Vault</Link>
    </div>
  );
}
